export interface InteriorTheme {
    id: 'classic' | 'modern' | 'traditional';
    name: string;
    description: string;
    icon: string;
    styleInfluences: string[];
    materialPreferences: string[];
    furnitureStyle: string;
    lightingStyle: string;
    colorPaletteCharacteristics: string;
    moodDescription: string;
}

export const INTERIOR_THEMES: InteriorTheme[] = [
    {
        id: 'classic',
        name: 'Classic',
        description: 'Timeless elegance with traditional European influences, symmetry, and refined details',
        icon: '🏛️',
        styleInfluences: ['Neoclassical', 'Georgian', 'Victorian', 'French Provincial'],
        materialPreferences: ['Hardwood Floors', 'Marble', 'Gilt Accents', 'Silk Drapery', 'Crystal'],
        furnitureStyle: 'Ornate carvings, cabriole legs, tufted upholstery, antique finishes',
        lightingStyle: 'Chandeliers, sconces, crystal fixtures, brass and bronze finishes',
        colorPaletteCharacteristics: 'Rich jewel tones, gold accents, deep woods, neutral backdrops',
        moodDescription: 'Luxurious, formal, timeless, sophisticated, elegant'
    },
    {
        id: 'modern',
        name: 'Modern',
        description: 'Clean lines, minimal ornamentation, and emphasis on function and form',
        icon: '📐',
        styleInfluences: ['Mid-Century Modern', 'Contemporary', 'Minimalist', 'Scandinavian'],
        materialPreferences: ['Glass', 'Steel', 'Concrete', 'Leather', 'Light Woods'],
        furnitureStyle: 'Sleek silhouettes, geometric forms, hidden storage, modular pieces',
        lightingStyle: 'Recessed lighting, track lighting, sculptural fixtures, LED integration',
        colorPaletteCharacteristics: 'Monochromatic schemes, neutral bases, bold accent colors',
        moodDescription: 'Clean, uncluttered, sophisticated, functional, airy'
    },
    {
        id: 'traditional',
        name: 'Traditional',
        description: 'Warm, comfortable spaces with historical references and layered details',
        icon: '🪴',
        styleInfluences: ['English Country', 'American Traditional', 'Colonial', 'Craftsman'],
        materialPreferences: ['Wool', 'Cotton', 'Wood Paneling', 'Brass Hardware', 'Stone'],
        furnitureStyle: 'Comfortable upholstery, turned legs, traditional silhouettes, family heirlooms',
        lightingStyle: 'Table lamps, floor lamps, shaded fixtures, warm ambient lighting',
        colorPaletteCharacteristics: 'Warm neutrals, earth tones, muted patterns, wood finishes',
        moodDescription: 'Cozy, inviting, familiar, comfortable, lived-in'
    }
];

export type InteriorThemeId = 'classic' | 'modern' | 'traditional';
export const DEFAULT_INTERIOR_THEME_ID: InteriorThemeId = 'modern';